import React from 'react';

import { SvgIcon, SvgIconProps } from '@mui/material';

import { ReactComponent as Icon } from './Stroke3Icon.svg';

/**
 * @function
 * Auto-generated file.
 */
export const Stroke3Icon = React.forwardRef<SVGSVGElement, SvgIconProps>(function Stroke3Icon(props, ref) {
  return (
    <SvgIcon ref={ref} viewBox="0 0 16 14" component={Icon} {...props} />
  );
});
